export default __webpack_public_path__ + "static/DUBIZZLELABS-WHITE-81b5317135bf2d267cd5873fdb389e0b.png";